import { cva } from '@/styled-system/css';

export const photoCarouselDotRecipe = cva({
  base: {
    alignItems: 'center',
    backgroundColor: 'icon.transparent.onImpact.neutral-fixed',
    borderRadius: 'shape.ellipse',
    boxShadow: 'none',
    display: 'inline-flex',
    justifyContent: 'center',
    transition: {
      _motionReduce: 'none',
      _motionSafe: '{0.2s linear}',
    },
  },
  variants: {
    isContinuation: {
      false: {},
      true: {
        height: 'indicator.xs',
        width: 'indicator.xs',
      },
    },
    isHidden: {
      false: {},
      true: {
        srOnly: true,
        // Make dot transitions smoother by not letting srOnly shrink them down to 1px
        width: 'indicator.xs',
        height: 'indicator.xs',
      },
    },
    selected: {
      false: {},
      true: {
        backgroundColor: 'icon.onImpact.neutral-fixed',
        height: 'indicator.md',
        width: 'indicator.md',
      },
    },
  },
  // Using compound variant to prevent srOnly styles from being overridden
  compoundVariants: [
    {
      isContinuation: false,
      isHidden: false,
      selected: false,
      css: {
        width: 'indicator.sm',
        height: 'indicator.sm',
      },
    },
  ],
});
